<template functional>
  <div class="text-xs-center pa-4">
    <div class="subheading mb-4">
      <slot name="title">{{ props.title }}</slot>
    </div>
    <div class="subheading primary--text">
      <slot name="text">{{ props.text }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nx-dashboard-info-message',
  functional: true,
  props: {
    title: String,
    text: String,
  },
};
</script>
